import {Component, inject, ViewChild, AfterViewInit, DestroyRef, ChangeDetectionStrategy} from "@angular/core"
import {Router, RouterOutlet, NavigationEnd, NavigationSkipped} from "@angular/router"
import {filter} from "rxjs/operators"
import {JobFarmGroupsTableComponent} from "@platform/components/job-farm-groups/job-farm-groups-table/job-farm-groups-table.component"
import {TableLayoutComponent} from "@platform/components/layouts/table-layout/table-layout.component"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-job-farm-groups-page",
    imports: [RouterOutlet, JobFarmGroupsTableComponent, TableLayoutComponent],
    templateUrl: "./job-farm-groups-page.component.html",
    styleUrl: "./job-farm-groups-page.component.scss",
})
export class JobFarmGroupsPageComponent implements AfterViewInit {
    private readonly router = inject(Router)
    private readonly destroyRef = inject(DestroyRef)
    @ViewChild(JobFarmGroupsTableComponent) jobFarmGroupsTable?: JobFarmGroupsTableComponent

    ngAfterViewInit() {
        this.checkAndHandleRoute()

        // NavigationSkipped counts too: two simultaneous navigations leave the first cancelled and the
        // second skipped, while the url still changes
        this.router.events
            .pipe(
                filter((event): event is NavigationEnd | NavigationSkipped => event instanceof NavigationEnd || event instanceof NavigationSkipped),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => {
                this.checkAndHandleRoute()
            })
    }

    private checkAndHandleRoute() {
        if (this.router.url.includes("/create")) this.jobFarmGroupsTable?.openCreateDialog()
    }
}
